<template>
<div>
	<b-breadcrumb class="flex-nowrap m-0 rounded-0" :items="breadcrumbs"/>
	<transition name="slide-left-only" appear>
		<div class="px-3 pt-3">
			<template v-if="serverMessage">
				<b-alert show v-html="serverMessage" variant="danger"/>
			</template>
			<div class="row mb-3">
				<div
				v-for="module in availableModules"
				class="col-12 col-md-6 col-lg-4 mb-3"
				>
					<router-link
					:to="module.enabled ? module.url : '#'"
					class="page-menu-item d-flex align-items-start h-100 position-relative"
					:class="module.enabled ? '' : 'page-menu-item-disabled'"
					>
						<span style="top: 4px;right: 4px;" v-if="module.enabled && module.badge" class="badge badge-danger badge-lg position-absolute" v-b-tooltip.html="module.tooltip ? module.tooltip : ''">
							<span class="fas fa-exclamation-circle fa-fw"></span> {{ module.badge }}
						</span>
						<div class="mr-3 text-muted">
							<template v-if="Array.isArray(module.icon)">
								<span class="fa-stack page-menu-item-icon">
								  <span :class="'fa-' + module.icon[0]" class="fal fa-stack-2x"></span>
								  <span :class="'fa-' + module.icon[1]" class="far fa-stack-1x" style="top: -.7em;"></span>
								</span>
							</template>
							<template v-else>
								<span
								:class="'page-menu-item-icon ' + (module.enabled ? 'fal' : 'fal') + ' fa-' + module.icon + ' fa-fw fa-2x'"
								>
								</span>
							</template>
						</div>
						<div class="d-flex flex-column text-truncate">
							<div class="line-height-1 text-truncate h6 m-0 mb-2 d-flex">
								{{ module.title }}
							</div>
							<div class="text-muted line-height-1 small text-muted text-wrap" v-html="module.description">
							</div>
						</div>
					</router-link>
					<!-- <div v-else class="d-flex h-100">
						<template v-for="n in parseInt(module.childrens.length / 2)">
							<div class="d-flex w-50 flex-column justify-content-between" :class="n === 0 ? 'ml-1' : 'mr-1'">
								<template v-for="(child, cindex) in module.childrens.slice((n - 1) * parseInt(module.childrens.length / 2), (n - 1) * parseInt(module.childrens.length / 2) + parseInt(module.childrens.length / 2))">
									<router-link :to="''" :class="cindex < (((n - 1) * parseInt(module.childrens.length / 2) + parseInt(module.childrens.length / 2)) - 1) ? 'mb-1' : ''" class="page-menu-item text-truncate d-flex align-items-center py-2">
										<span
										:class="'fal ' + ' fa-' + child.icon + ' fa-fw h4 m-0 mr-2'"
										style="color: #3296d7; --fa-primary-color: #3296d7; --fa-secondary-color: #009bff;"
										>
										</span>
										<span class="h6 m-0 text-truncate">{{ child.title }}</span>
									</router-link>
								</template>
							</div>
						</template>
					</div> -->
				</div>
			</div>
		</div>
	</transition>
</div>
</template>

<script>
export default {
	name: 'home',
	data () {
		return {
			serverMessage: null,
			breadcrumbs: [
			{
				text: 'Главная',
				active: true
			}
			]
		}
	},
	components: {
	},
	computed: {
		profile () {
			return this.$store.getters.profile
		},
		availableModules () {
			var arr = []

			arr.push({
				title: 'Профилактика правонарушений',
				description: 'Внеплановые проверки. Объекты контроля. Профили рисков.',
				url: 'checkups',
				icon: 'clipboard-list-check',
				enabled: this.$store.getters.permissions.includes('enable_control_lists_list') || this.$store.getters.permissions.includes('enable_consultations_list') || this.$store.getters.permissions.includes('enable_forewarnings_list') || this.$store.getters.permissions.includes('enable_visits_list'),
				badge: 0
			})

			arr.push({
				title: 'Контрольные (надзорные) мероприятия',
				description: 'В отношении граждан',
				url: '/violations',
				icon: 'gavel',
				enabled: this.$store.getters.permissions.includes('enable_violations_list'),
				badge: 0
			})

			arr.push({
				title: 'Контрольные (надзорные) мероприятия',
				description: 'В отношении юридических лиц и индивидуальных предпринимателей',
				url: '/violations',
				icon: 'gavel',
				enabled: this.$store.getters.permissions.includes('enable_violations_list'),
				badge: 0
			})

			arr.push({
				title: 'Контроль чрезвычайных происшествий',
				description: 'Реестр сведений о ЧП, гео-данные событий и контроль реагирования',
				url: '/emergency_cases',
				icon: 'siren-on',
				enabled: this.$store.getters.permissions.includes('enable_emergency_cases_list'),
				badge: 0
			})

			arr.push({
				title: 'Регистрация и учет сетных орудий лова',
				description: 'Реестр сведений о зарегистрированных и промаркированных сетных орудиях лова',
				url: '/fishing_gears',
				icon: 'toolbox',
				enabled: this.$store.getters.permissions.includes('enable_fishing_gears_list'),
				badge: 0
			})

			arr.push({
				title: 'Обращения граждан',
				description: 'По фактам нарушения законодательства в области рыболовства и сохранения ВБР',
				url: '/reports',
				icon: 'comment-alt-exclamation',
				enabled: false,
				badge: 0
			})

			arr.push({
				title: 'Согласование хозяйственной деятельности',
				description: 'Хозяйственная, НДС и условия водопользования. Меры контроля.',
				url: '/projects',
				icon: 'folders',
				enabled: this.$store.getters.permissions.some(o => ['enable_hoz_projects_list', 'enable_nds_projects_list', 'enable_wateruse_projects_list'].includes(o)),
				badge: 0
			})

			arr.push({
				title: 'Рыболовные и рыбоводные участки',
				description: 'Участки, договоры пользования. Карты.',
				url: '/watersites',
				icon: 'vector-square',
				enabled: this.$store.getters.permissions.includes('enable_watersites_list') || this.$store.getters.permissions.includes('enable_contracts_list'),
				badge: 0
			})

			arr.push({
				title: 'Искусственное воспроизводство ВБР',
				description: 'Предложения, заявления, приказы, акты и договоры',
				url: '/activities',
				icon: ['hands', 'fish'],
				enabled: this.$store.getters.permissions.some(o => ['enable_proposals_list', 'enable_activities_list'].includes(o)),
				badge: 0,
			})

			arr.push({
				title: 'Статистическая отчетность',
				description: 'Отчетность по деятельности Росрыболовства и его территориальных органов',
				url: '/reports',
				icon: 'chart-bar',
				enabled: this.profile,
				badge: 0
			})

			arr.push({
				title: 'Аналитика',
				description: 'Инструменты для свода и анализа данных из разных списков и источников',
				url: '/analytics',
				icon: 'magnifying-glass-chart',
				enabled: this.profile && !!this.profile.is_admin,
				badge: 0
			})

			if (this.profile && this.profile.is_admin) {
				arr.push({
					title: 'Система',
					description: 'Администрирование, управление пользователями, инструменты для работы с данными.',
					url: '/system',
					icon: 'cog',
					enabled: true,
					badge: 0
				})
			}

			return arr
		}
	},
	methods: {
	},
	mounted () {
		let syncUrl = process.env.VUE_APP_API_ROOT + '/api/sync'

		this
			.$http
			.get(syncUrl)
			.then(res => {
				if (res.data.department_access_main) {
					this.$store.commit('setDepartmentAccessMain', res.data.department_access_main)
				}
				if (res.data.departments) {
					this.$store.commit('setDepartments', res.data.departments)
				}
				if (res.data.regions) {
					this.$store.commit('setRegions', res.data.regions)
				}
				if (res.data.permissions) {
					this.$store.commit('setPermissions', res.data.permissions)
				}
				if (res.data.server_message) {
					this.serverMessage = res.data.server_message
				}
			})
	},
	watch: {
	}
}
</script>